/**
 * LuaGate 共通定数。
 * チームID や既定コース名など、複数ページで重複していたリテラルを集約する。
 */

// LuaGate チームの teamId (本番固定)
export const LUAGATE_TEAM_ID = "87d4d04b-0069-488f-9d2c-80b18f1dddb0";

// 既定コース (lp_course_id = null のレッスン群) の分野名。
// 表示時に「学習パス」を静的に付与する (例: 基本エンジニア学習パス)。
export const DEFAULT_LP_NAME = "基本エンジニア";

/** LuaGate ポータルで表示する正式なブランド名。 */
export const LUAGATE_BRAND_NAME = "ゆめさくエンジニア";

/** ページ固有名があるときだけブランド名を suffix に付ける。 */
export function buildLuagatePageTitle(pageName?: string | null): string {
  const normalized = pageName?.trim();
  return normalized
    ? `${normalized} | ${LUAGATE_BRAND_NAME}`
    : LUAGATE_BRAND_NAME;
}
